import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import './stepper-item.scss'

const StepConnector = (props) => {
	const { coloredConnector, completed, active, disabled, showOnlyCurrentStep, connectorProps } = props
	return (
		<div
			className={clsx(
				'Vb-step-connector',
				showOnlyCurrentStep && 'Vb-step-connector--hidden'
			)}
			style={connectorProps ? connectorProps?.style : null}
			{...connectorProps}
		>
			<span
				className={clsx(
					'Vb-step-connector__line',
					coloredConnector && ((!disabled && active) || completed) && 'Vb-step-connector__line--colored'
				)}
			/>
		</div>
	)
}

const StepperItem = React.forwardRef(function Stepper(props, ref) {
	const {
		active,
		children,
		className,
		coloredConnector,
		completed,
		disabled,
		index,
		onClick,
		small,
		showOnlyCurrentStep,
		startFromZero,
		last,
		connectorProps,
		...other
	} = props

	const handleOnClick = () => {
		if (!disabled && !active) {
			onClick && onClick()
		}
	}

	return (
		<>
			{index !== 0 && <StepConnector {...props} />}
			<button
				ref={ref}
				index={index}
				onClick={handleOnClick}
				className={clsx(
					'Vb-step',
					showOnlyCurrentStep && !active && 'Vb-step--hidden'
				)}
				{...other}
			>
				<span
					className={clsx(
						'Vb-step__indicator',
						small && 'Vb-step__indicator--small',
						!disabled && (active || completed) && 'Vb-step__indicator--active-completed'
					)}
				>
					<span>{index + !startFromZero * 1}</span>
				</span>
				<span
					className={clsx(
						'Vb-step__label',
						small && 'Vb-step__label--small',
						disabled && 'Vb-step__label--disabled',
						active && !disabled && 'Vb-step__label--active'
					)}
				>
					<span>{children}</span>
				</span>
			</button>
		</>
	)
})

export default StepperItem

StepperItem.propTypes = {
	/**
	 * @ignore
	 */
	active: PropTypes.bool,
	/**
	 * Content of the step label.
	 */
	children: PropTypes.node,
	/**
	 * @ignore
	 */
	className: PropTypes.string,
	/**
	 * If true, the line between steps will be colored the same way
	 * the number indicator when completed.
	 * @default false
	 */
	coloredConnector: PropTypes.bool,
	/**
	 * If true, the step indicator will be displayed in green color.
	 * @default false
	 */
	completed: PropTypes.bool,
	/**
	 * @ignore
	 */
	disabled: PropTypes.bool,
	/**
	 * @ignore
	 */
	index: PropTypes.number,
	/**
	 * Funtion to execute on step clicking.
	 */
	onClick: PropTypes.func,
	/**
	 * If `true`, the Step is displayed as rendered last.
	 * The prop defaults to the value inherited from the parent Stepper component.
	 */
	last: PropTypes.bool,
	/**
	 * @ignore
	 */
	startFromZero: PropTypes.bool
}
